import Modal from "react-modal"
import TieupImg from "src/components/common/TieupImg"
import clsx from "clsx"
import styles from "./GiftingFirstVisitModal.module.scss"

type Props = {
  onClose: () => void
}

const GiftingFirstVisitModal: React.FC<Props> = ({ onClose }) => {
  return (
    <Modal
      className="p-modal"
      overlayClassName={clsx({
        "p-modal-overlay": true,
        "is-show": true,
      })}
      ariaHideApp={false}
      isOpen={true}
    >
      <div className={styles.modal_inner}>
        <div className={styles.modal_contents}>
          <div className={styles.modal_contents_inner}>
            <div>
              <TieupImg src="/img/gift/gift_first_visit.png" />
            </div>
            <h3 className={styles.modal_contents_title}>
              ギフトをはじめよう！
            </h3>
            <p className={styles.modal_contents_text}>
              作品に感動したり素敵だと思ったら、作者を応援しましょう！ <br />
              気持ちを届けることは創作の支えになります。
            </p>
            <button onClick={onClose} className={styles.modal_contents_button}>
              閉じる
            </button>
          </div>
        </div>
      </div>
    </Modal>
  )
}

export default GiftingFirstVisitModal
